import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const CONFIRMATION_MODAL_STYLES = {
    content: {
        padding: 0,
        width: 550,
    },
};

export const StyledConfirmationModalTitle = styled.h4`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    line-height: 24px;
    margin: 20px 0 36px;
`;

export const StyledConfirmationModalContent = styled.div`
    user-select: none;
`;

export const StyledConfirmationModalButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
    padding: 16px 0;
`;

export const StyledConfirmationModalLabel = styled.label`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    line-height: 20px;
    margin-bottom: 16px;
`;

export const StyledModalErrorBannerWrapper = styled.div`
    margin-bottom: 16px;
`;

export const StyledConfirmationModalInner = styled.div`
    padding-left: 24px;
    padding-right: 24px;
`;
